import {
  createFileRoute,
} from '@tanstack/react-router';
import {
  fallback, zodValidator,
} from '@tanstack/zod-adapter';
import {
  z,
} from 'zod';

import Pricing from '#features/landing/Pricing';

const PricingSearchSchema = z.object({
  selected: fallback(z.enum([
    'Yearly',
    'Monthly',
  ]), 'Monthly').optional(),
});

export const Route = createFileRoute('/_app/_landing/pricing')({
  component: RouteComponent,
  validateSearch: zodValidator(PricingSearchSchema),
});

function RouteComponent() {
  return (
    <Pricing></Pricing>
  );
}
